import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ExpandableSection } from './ExpandableSection';
function VehicleComments({ opmerkingen, opmerkingen_frans }) {
    // const localizedComments = ss.i18n.currentLocale === 'fr_BE' ? opmerkingen_frans : opmerkingen
    const localizedComments = opmerkingen;
    if (!localizedComments)
        return null;
    return (_jsx("div", { className: "detail-content-box detail-content-box--comments", children: _jsx(ExpandableSection, { children: _jsxs(_Fragment, { children: [_jsx("div", { className: "detail-content-heading", children: "Comments" }), _jsx("div", { className: "hexon-comments", dangerouslySetInnerHTML: { __html: localizedComments } })] }) }) }));
}
export { VehicleComments };
